import Router from "routes";
import GlobalStyle from "styles/global";

const App = () => {
  return (
    <>
      <GlobalStyle />
      <Router />
    </>
  );
};

export default App;
